import { DcddRegistrationCategory } from "props/enum";
import { DcddUserInput, DcddUserInputError } from "../../state/actionType";

export const DcddFormValidation = (data: DcddUserInput): DcddUserInputError => {
  const errors: DcddUserInputError = {};

  if (!data.name?.trim()) {
    errors.name = "User name cannot be empty.";
  }
  if (!data.gender?.trim()) {
    errors.gender = "User gender cannot be empty.";
  }
  if (!data.category?.trim()) {
    errors.category = "Please select category.";
  }
  if (!data.password?.trim()) {
    errors.password = "Enter Password.";
  }

  if (data.category === DcddRegistrationCategory.HOME) {
    if (!data.dzongkhag_id?.trim()) {
      errors.dzongkhag_id = "Please select dzongkhag.";
    }
    if (!data.dob?.trim()) {
      errors.dob = "Enter user date of birth.";
    }
    if (!data.cid?.trim()) {
      errors.cid = "Enter user cid.";
    }
    const hasEmail = data.email?.trim();
    const hasMobile = data.mobile_no?.trim();

    if (!hasEmail && !hasMobile) {
      errors.email = "Enter email.";
      errors.mobile_no = "Enter mobile number.";
    }
  }
  if (data.category === DcddRegistrationCategory.ECCD) {
    if (!data.dzongkhag_id?.trim()) {
      errors.dzongkhag_id = "Please select dzongkhag.";
    }
    if (!data.dob?.trim()) {
      errors.dob = "Enter user date of birth.";
    }
    if (!data.cid?.trim()) {
      errors.cid = "Enter user cid.";
    }
    if (!data.eccd_id?.trim()) {
      errors.eccd_id = "Please select ECDD.";
    }
     const hasEmail = data.email?.trim();
    const hasMobile = data.mobile_no?.trim();

    if (!hasEmail && !hasMobile) {
      errors.email = "Enter email.";
      errors.mobile_no = "Enter mobile number.";
    }
  }
  if (data.category === DcddRegistrationCategory.STUDENT) {
    if (!data.dzongkhag_id?.trim()) {
      errors.dzongkhag_id = "Please select dzongkhag.";
    }
    if (!data.dob?.trim()) {
      errors.dob = "Enter user date of birth.";
    }
    if (!data.school_id?.trim()) {
      errors.school_id = "Please select school.";
    }
    if (!data.grade_id?.trim()) {
      errors.grade_id = "Please select grade.";
    }
    if (!data.student_id?.trim()) {
      errors.student_id = "Enter student Id.";
    }
     const hasEmail = data.email?.trim();
    const hasMobile = data.mobile_no?.trim();

    if (!hasEmail && !hasMobile) {
      errors.email = "Enter email.";
      errors.mobile_no = "Enter mobile number.";
    }
  }
  if (data.category === DcddRegistrationCategory.DZONGKHA_TEACHER) {
    if (!data.dzongkhag_id?.trim()) {
      errors.dzongkhag_id = "Please select dzongkhag.";
    }
    if (!data.school_id?.trim()) {
      errors.school_id = "Please select school.";
    }
    const hasEmail = data.email?.trim();
    const hasMobile = data.mobile_no?.trim();

    if (!hasEmail && !hasMobile) {
      errors.email = "Enter email.";
      errors.mobile_no = "Enter mobile number.";
    }
  }
  if (data.category === DcddRegistrationCategory.ECCD_FACILITATOR) {
    if (!data.dzongkhag_id?.trim()) {
      errors.dzongkhag_id = "Please select dzongkhag.";
    }
    if (!data.eccd_id?.trim()) {
      errors.eccd_id = "Please select school.";
    }
    const hasEmail = data.email?.trim();
    const hasMobile = data.mobile_no?.trim();

    if (!hasEmail && !hasMobile) {
      errors.email = "Enter email.";
      errors.mobile_no = "Enter mobile number.";
    }
  }

  return errors;
};

export default DcddFormValidation;
